import React from "react";

export function collapseProducts(
  ref: React.MutableRefObject<any>,
  isMobile: boolean,
  imageSize?: "small" | "medium" | "large" | "largest" | undefined,
  maxImagesOverride?: number
) {
  /** Setting Max number of images defaults */
  const DESKTOP_MAX_IMAGES = maxImagesOverride ? maxImagesOverride : imageSize === "small" ? 8 : 5;
  const MOBILE_MAX_IMAGES = maxImagesOverride ? maxImagesOverride : imageSize === "small" ? 5 : 3;

  const maxImages = isMobile ? MOBILE_MAX_IMAGES : DESKTOP_MAX_IMAGES;
  const childNodes = [...ref!.current!.childNodes];
  let childElementCount = ref!.current!.childElementCount;

  for (const ele of childNodes) {
    ele.classList.remove("smartrr-hidden");
    ele.localName === "span" && childElementCount--;
  }
  if (childElementCount > maxImages) {
    for (let index = childElementCount; index >= maxImages; index--) {
      childNodes[index] &&
        childNodes[index].localName === "div" &&
        childNodes[index].classList.add("smartrr-hidden"); // Prevents hiding of <span> within grid
    }
    return childElementCount - maxImages;
  }
}
